import reducer from './ascendReducer';
import actions from './ascendActions';
import selectors from './ascendSelectors';

export default {
  reducer,
  actions,
  selectors,
};
